global.CucumberHTML = require('cucumber-html');
module.exports = require('../../lib/cucumber');
